/**
 * Supabase client singleton.
 * Per app.pact.constraint.backend.003: SINGLE BACKEND. ONE Supabase project.
 * Per app.pact.constraint.tenant.001: ONE FAMILY per deployment. No tenant_id.
 */
import { createClient } from '@supabase/supabase-js'

const supabaseUrl = (import.meta as any).env?.VITE_SUPABASE_URL ?? 'http://localhost:54321'
const supabaseAnonKey = (import.meta as any).env?.VITE_SUPABASE_ANON_KEY ?? 'placeholder-anon-key'

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
})

export type SupabaseClient = typeof supabase
